import { render, staticRenderFns } from "./MaintenanceBanner.vue?vue&type=template&id=435b88b3&scoped=true"
import script from "./MaintenanceBanner.vue?vue&type=script&lang=js"
export * from "./MaintenanceBanner.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceBanner.vue?vue&type=style&index=0&id=435b88b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435b88b3",
  null
  
)

export default component.exports